export const Buttons = {
    POST_A_BRIEF: 'post_a_brief',
    EXPERT_SOURCING: 'expert_sourcing',
};
